<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Фоны</h4>
                            <p class="card-category"></p>

                            <div class="row mt10">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Категория</label>
                                        <select v-model="categoryId" id="category-filter"
                                                @change="saveFilters('ii_category', categoryId)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option v-for="c in categories" v-bind:value="c.id">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="status" id="status-filter"
                                                @change="saveFilters('ii_status', status)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="1">Активен</option>
                                            <option value="0">Не активен</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Фильтровать
                                    </button>
                                </div>
                                <div class="col-md-4"></div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-success btn-fill float-right"
                                            @click.prevent="add">
                                        Добавить фон
                                    </button>
                                </div>
                            </div>

                        </template>
                        <div class="table-responsive">
                            <table class="table" v-bind:class="{ 'loading-state': loading }">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'sort'">сортировка</span>
                                        <span v-else-if="column === 'name'">название</span>
                                        <span v-else-if="column === 'url_small_full'">фон</span>
                                        <span v-else-if="column === 'status'">статус</span>
                                        <span v-else-if="column === 'is_premium'">премиум</span>
                                        <span v-else-if="column === 'category'">категория</span>
                                        <span v-else>{{column}}</span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data">
                                    <slot :row="item">
                                        <td v-for="column in columns">
                                            <span v-if="column === 'is_premium'">
                                                <img class="premium" src="/static/img/premium.png" v-if="item[column] === 1"/>
                                            </span>
                                            <div v-else-if="column === 'url_small_full'" @click="edit(item['id'])">
                                                <div class="device-block device1"
                                                     :style="{ backgroundImage: 'url(' + item[column] + ')', backgroundPosition: 'center center' }">
                                                </div>
                                            </div>
                                            <span v-else-if="column === ''">
                                                <a class="text-primary" @click="edit(item['id'])">Изменить</a>
                                              </span>
                                            <span v-else-if="column === 'status'">
                                                <span class="text-success" v-if="item[column] === 1">Активен</span>
                                                <span class="text-warning" v-if="item[column] === 0">Не активен</span>
                                              </span>
                                            <span v-else>{{ item[column] }}</span>
                                        </td>
                                    </slot>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div :class="{ 'disabled' : data.length < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="next">
                            След.
                        </div>
                        <div :class="{ 'disabled' : offset < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="prev">
                            Пред.
                        </div>
                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
const axios = require('axios')
import LTable from 'src/components/UIComponents/Table.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    components: {
        LTable,
        Card
    },
    created: function () {
        this.init();
    },
    data() {
        return {
            columns: ['id', 'url_small_full', 'category',  'is_premium', 'sort', 'status', ''],
            limit: 10,
            offset: parseInt(localStorage.getItem('ii_active_offset')) || 0,
            data: [],
            categories: [],
            status: localStorage.getItem('ii_status') ? localStorage.getItem('ii_status') : "",
            categoryId: localStorage.getItem('ii_category') ? localStorage.getItem('ii_category') : "",
            loading: false
        }
    },
    methods: {
        init: function () {
            this.get()
        },
        filter: function () {
            this.offset = 0;
            localStorage.setItem('ii_active_offset', parseInt(this.offset));

            this.get();
        },
        add: function () {
            this.$router.push('/images/create');
        },
        get: function () {
            let self = this;

            let token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(
                `${this.$hostname}/admin/images/`,
                {
                    'params': {
                        status: this.status,
                        categoryId: self.categoryId,
                        limit: self.limit,
                        offset: self.offset,
                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.data = response.data.images;

                    self.categories = response.data.categories;
                    localStorage.setItem('ii_categories', JSON.stringify(self.categories));

                    self.loading = false;
                })
                .catch(function (error) {
                    self.loading = false;
                    console.log(error)
                })
        },
        edit: function (id) {
            this.$router.push({
                name: 'edit-image',
                params: {id: id}
            });
        },
        prev: function () {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('ii_active_offset', parseInt(this.offset));
            }
        },
        next: function () {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('ii_active_offset', parseInt(this.offset));
            }
        },
        saveFilters: function(name, value) {
            localStorage.setItem(name, value);
        },

    },
    beforeRouteLeave (to, from , next) {
        if (to.path.indexOf('images') < 1) {
            localStorage.setItem('ii_active_offset', "");
            localStorage.setItem('ii_category', "");
            localStorage.setItem('ii_status', "");
        }
        next();
    },
}
</script>
<style scoped>
.pagination-button {
    height: 30px;
    padding: 1px 16px;
    margin-left: 20px;
    color: #fff !important;
}
.pagination-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
.mt10 {
    margin-top: 10px;
}
.device1 {
    display: block;
    width: 90px;
    height: 160px;
    border-radius: 8px;
    background-size: cover;
    cursor: pointer;
}

.btn-fill {
    margin-top: 25px;
}
.text-primary {
    cursor: pointer;
}
.premium {
    width: 30px;
    margin-left: 20px;
}
th {
    padding: 12px 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Images.vue